<template>
  <v-container fluid class="savitarna-left-menu">
    <div v-html="content" />
    <template v-if="showSideInfo">
      <div id="content-in">
        <div class="left">
          <div class="side-info-box">
            <div v-html="sideInfo" />
          </div>
        </div>
      </div>
    </template>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import request from '@/util/savitarnaMenu'
import headerData from './headerData'

export default {
  name: 'SavLeftMenu',
  mixins: [headerData],
  data() {
    return {
      content: null,
    }
  },
  computed: {
    ...mapGetters(['infoTooltips', 'savitarnaXid']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    showSideInfo() {
      return this.sideInfo
    },
    tooltipKodas() {
      return this.$route.meta.menuTooltip ?? null
    },
    tooltipItem() {
      return (
        this.infoTooltips.find(
          item => item.too_kodas === this.tooltipKodas && item.too_aktyvus
        ) ?? {}
      )
    },
    sideInfo() {
      return this.tooltipItem.too_tekstas ?? null
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.isLocal) {
        request({
          url: `menu.do;jsessionid=${this.savitarnaXid}`,
          method: 'get',
        }).then(res => {
          this.content = this.parseLeftMenu(res.data)
          this.$emit('loaded')
        })
      } else {
        if (this.isLocal) {
          this.content = this.parseLeftMenu(this.menuData)
          this.$emit('loaded')
        }
      }
    },
    parseLeftMenu(data) {
      data = data.replace(/^.*?(?=<div id="content-in">)/s, '')
      data = data.replace(/(?=<div class="content-info">).*?$/s, '')

      return data
    },
  },
}
</script>

<style lang="scss">
.savitarna-left-menu {
  padding: 0;
  margin: 0;
}
div#content-in ul.side-menu li a {
  width: 219px;
}
.side-menu a {
  width: 100% !important;
}
</style>
